export default __webpack_public_path__ + "static/media/illustration-health-2-w@3x.5bd88314.webp";